import Vue from "vue";
import Router from "vue-router";

// in development-env not use lazy-loading, because lazy-loading too many pages will cause webpack hot update too slow. so only in production use lazy-loading;
// detail: https://panjiachen.github.io/vue-element-admin-site/#/lazy-loading

Vue.use(Router);

/* Layout */
import Layout from "../views/layout/Layout";
/**
* hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
* alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
*                                if not set alwaysShow, only more than one route under the children
*                                it will becomes nested mode, otherwise not show the root menu
* redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
* name:'router-name'             the name is used by <keep-alive> (must set!!!)
* meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
**/

function notRequireAuth(to, from, next) {
  next();
}

export const constantRouterMap = [
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () => import('@/views/login/index'),
  //   beforeEnter: notRequireAuth,
  //   hidden: true
  // },
  {
    path: "/NanoVerify",
    component: Layout,
    children: [
      {
        path: "/NanoVerify",
        name: "Public-NanoVerify",
        component: () => import("@/views/certificateNanoverify/public"),
        meta: {
          title: "NanoVerify",
          icon: "dashboard",
          class: "material-icons",
          size: "16px",
          special: false
        }
      }
    ],
    beforeEnter: notRequireAuth
  },
  {
    path: "/GrapheneVerify",
    component: Layout,
    children: [
      {
        path: "",
        name: "Public-GrapheneVerify",
        component: () => import("@/views/certificateGrapheneVerify/public"),
        meta: {
          title: "GrapheneVerify",
          icon: "dashboard",
          class: "material-icons",
          size: "16px",
          special: false
        }
      }
    ],
    beforeEnter: notRequireAuth
  },
  {
    path: "/NanoTrust",
    component: Layout,
    children: [
      {
        path: "",
        name: "Public-NanoTrust",
        component: () => import("@/views/certificateNanoTrust/public"),
        meta: {
          title: "NanoTrust",
          icon: "dashboard",
          class: "material-icons",
          size: "16px",
          special: false
        }
      }
    ],
    beforeEnter: notRequireAuth
  },
  {
    path: "/NT-NanoMark",
    component: Layout,
    children: [
      {
        path: "",
        name: "Public-NT-NanoMark",
        component: () => import("@/views/certificateNanoMark/public"),
        meta: {
          title: "NT-NanoMark",
          icon: "dashboard",
          class: "material-icons",
          size: "16px",
          special: false
        }
      }
    ],
    beforeEnter: notRequireAuth
  },
  // {
  //   path: '/forgot-password',
  //   name: 'forgot-password',
  //   component: () => import('@/views/forgot-password/index'),
  //   beforeEnter: notRequireAuth,
  //   hidden: true
  // },
  // {
  //   path: '/reset-password',
  //   name: 'reset-password',
  //   component: () => import('@/views/reset-password/index'),
  //   beforeEnter: notRequireAuth,
  //   hidden: true
  // },
  // {
  //   path: '/email-pending',
  //   name: 'email-pending',
  //   component: () => import('@/views/email-pending/index'),
  //   beforeEnter: notRequireAuth,
  //   hidden: true
  // },
  // {
  //   path: '/email-confirmation',
  //   name: 'email-confirmation',
  //   component: () => import('@/views/email-confirmation/index'),
  //   beforeEnter: notRequireAuth,
  //   hidden: true
  // },
  {
    path: "/privacy-policy",
    name: "privacy-policy",
    component: () => import("@/views/privacy-policy/index.vue"),
    hidden: true
  },
  {
    path: "/404",
    redirect: { name: "Landing Page" },
    hidden: true
  }
];

export default new Router({
  mode: "history",
  routes: constantRouterMap,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

// merchant
export const asyncRouterMap = [
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'Home',
  //       component: () => import('@/views/certificateNanoverify/index'),
  //       meta: {
  //         title: 'NanoVerify',
  //         icon: 'dashboard',
  //         class: 'material-icons',
  //         size: '16px',
  //         special: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: 'GrapheneVerify',
  //       name: 'GrapheneVerify',
  //       component: () => import('@/views/certificateGrapheneVerify/index'),
  //       meta: {
  //         title: 'GrapheneVerify',
  //         icon: 'dashboard',
  //         class: 'material-icons',
  //         size: '16px',
  //         special: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: 'NanoTrust',
  //       name: 'NanoTrust',
  //       component: () => import('@/views/certificateNanoTrust/index'),
  //       meta: {
  //         title: 'NanoTrust',
  //         icon: 'dashboard',
  //         class: 'material-icons',
  //         size: '16px',
  //         special: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/change-password',
  //   component: Layout,
  //   hidden: true,
  //   meta: {},
  //   children: [
  //     {
  //       path: '',
  //       name: 'Change Password',
  //       component: () => import('@/views/changePassword/index'),
  //       meta: { title: 'Change Password', icon: 'form' }
  //     }
  //   ]
  // },
  { path: "*", redirect: "/404", hidden: true }
];

// admin
export const adminRouterMap = [
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: 'index',
  //       name: 'Home',
  //       component: () => import('@/views/certificateNanoverify/index'),
  //       meta: {
  //         title: 'NanoVerify',
  //         icon: 'dashboard',
  //         class: 'material-icons',
  //         size: '16px',
  //         special: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: 'GrapheneVerify',
  //       name: 'GrapheneVerify',
  //       component: () => import('@/views/certificateGrapheneVerify/index'),
  //       meta: {
  //         title: 'GrapheneVerify',
  //         icon: 'dashboard',
  //         class: 'material-icons',
  //         size: '16px',
  //         special: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '',
  //   component: Layout,
  //   redirect: '/',
  //   children: [
  //     {
  //       path: 'NanoTrust',
  //       name: 'NanoTrust',
  //       component: () => import('@/views/certificateNanoTrust/index'),
  //       meta: {
  //         title: 'NanoTrust',
  //         icon: 'dashboard',
  //         class: 'material-icons',
  //         size: '16px',
  //         special: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/institute-management',
  //   component: Layout,
  //   meta: {},
  //   children: [
  //     {
  //       path: '',
  //       name: 'Users',
  //       component: () => import('@/views/adminUserManagement/index'),
  //       meta: {
  //         title: 'Users',
  //         icon: 'form',
  //         size: '16px',
  //         special: false
  //       }
  //     }
  //   ]
  // },
  // {
  //   path: '/change-password',
  //   component: Layout,
  //   hidden: true,
  //   meta: {},
  //   children: [
  //     {
  //       path: '',
  //       name: 'Change Password',
  //       component: () => import('@/views/changePassword/index'),
  //       meta: { title: 'Change Password', icon: 'form' }
  //     }
  //   ]
  // },
  { path: "*", redirect: "/404", hidden: true }
];

export const userRouterMap = [
  {
    path: "/certificate",
    component: Layout,
    hidden: true,
    meta: {},
    children: [
      {
        path: ":id",
        name: "certificate",
        component: () => import("@/views/certificate/index"),
        meta: { title: "Certificate", icon: "fileText" }
      },
      {
        path: "",
        redirect: { name: "Home" }
      }
    ]
  },

  {
    path: "*",
    redirect: "/404",
    hidden: true
  }
];



// WEBPACK FOOTER //
// ./src/router/index.js